import { c as _c } from "react/compiler-runtime";
import { FormInputSearch } from '@systemeio/ui';
import TabMenu from 'modules/calendar/components/tab-menu';
import { calendarLoco } from 'modules/calendar/constants/calendar-loco';
import { removeEvent } from 'modules/calendar/events/api/events-api';
import { EventCreateModal } from 'modules/calendar/events/components/event-create-modal';
import { eventTypeLocoKeys } from 'modules/calendar/events/enums/event-type-enum';
import { useEventLimitReached } from 'modules/calendar/events/hooks/use-event-limit-reached';
import { useEvents } from 'modules/calendar/events/hooks/use-events';
import { EventFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { EventListInterface } from 'modules/calendar/events/types/new-event-interface';
import { NextPage } from 'next';
import React from 'react';
import { TIME_LABELS, TimeType } from 'shared/components/date-picker/time-delay-picker/constants';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
const defaultFilters: EventFilterInterface = {
  name: ''
};
const Calendar: NextPage = () => {
  const $ = _c(80);
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters);
  let t0;
  if ($[0] !== filter || $[1] !== limit || $[2] !== pagination) {
    t0 = {
      limit,
      pagination,
      filter
    };
    $[0] = filter;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    events,
    counter
  } = useEvents(t0);
  const {
    eventLimit,
    isFetchingEventLimit
  } = useEventLimitReached();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[4] !== t) {
    t1 = t("dashboard.calendar.event_name");
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = {
      key: "name",
      header: t1,
      widthPercent: 60,
      onRender: _temp
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("dashboard.calendar.event_duration");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== tICU) {
    t4 = event_0 => <span>{event_0.eventDuration}{" "}{tICU(TIME_LABELS[TimeType.MINUTES], {
        count: event_0.eventDuration
      })}</span>;
    $[10] = tICU;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = {
      key: "eventDuration",
      header: t3,
      widthPercent: 40,
      onRender: t4
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t) {
    t6 = t("dashboard.calendar.event_type");
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t) {
    t7 = event_1 => <span>{t(eventTypeLocoKeys[event_1.eventType])}</span>;
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = {
      key: "eventType",
      header: t6,
      widthPercent: 30,
      onRender: t7
    };
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t2 || $[23] !== t5 || $[24] !== t8) {
    t9 = [t2, t5, t8];
    $[22] = t2;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const columns = t9;
  let t10;
  if ($[26] !== revalidateModules) {
    t10 = async event_2 => {
      await removeEvent(event_2.id);
      await revalidateModules([RequestModuleEnum.Calendar, RequestModuleEnum.CalendarBookings], true);
    };
    $[26] = revalidateModules;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const onRemoveEvent = t10;
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <TabMenu />;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("dashboard.calendar.title_events");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = eventLimit?.limitReached;
  let t14;
  if ($[31] !== isFetchingEventLimit || $[32] !== t13) {
    t14 = <EventCreateModal isFetchingEventLimit={isFetchingEventLimit} limitReached={t13} />;
    $[31] = isFetchingEventLimit;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== filter || $[35] !== setFilter) {
    t15 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[34] = filter;
    $[35] = setFilter;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== pagination || $[38] !== setPagination) {
    t16 = {
      pagination,
      setPagination
    };
    $[37] = pagination;
    $[38] = setPagination;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== limit || $[41] !== setLimit) {
    t17 = {
      limit,
      setLimit
    };
    $[40] = limit;
    $[41] = setLimit;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [{
      field: "name",
      onRender: _temp2
    }];
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t15 || $[45] !== t16 || $[46] !== t17) {
    t19 = {
      filterer: t15,
      paginator: t16,
      limiter: t17,
      testAttributePostfix: "filter-btn",
      filterable: t18
    };
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t) {
    t20 = t("dashboard.calendar.title_event");
    $[48] = t;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== limit || $[51] !== setLimit) {
    t21 = {
      limit,
      setLimit
    };
    $[50] = limit;
    $[51] = setLimit;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== pagination || $[54] !== setPagination) {
    t22 = {
      pagination,
      setPagination
    };
    $[53] = pagination;
    $[54] = setPagination;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      setHref: _temp3,
      isNext: true
    };
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== onRemoveEvent) {
    t24 = event_4 => onRemoveEvent(event_4);
    $[57] = onRemoveEvent;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  let t26;
  if ($[59] !== t) {
    t25 = event_5 => event_5.hasActiveBookings ? t("dashboard.calendar.remove_paid_event") : t("dashboard.calendar.remove_free_event");
    t26 = event_6 => event_6.hasActiveBookings && t("dashboard.calendar.remove_paid_event_title");
    $[59] = t;
    $[60] = t25;
    $[61] = t26;
  } else {
    t25 = $[60];
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t24 || $[63] !== t25 || $[64] !== t26) {
    t27 = {
      edit: t23,
      remove: {
        onChange: t24,
        confirmationText: t25,
        confirmationTitle: t26
      }
    };
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== columns || $[67] !== events || $[68] !== t20 || $[69] !== t21 || $[70] !== t22 || $[71] !== t27) {
    t28 = <Table caption={t20} data={events} columns={columns} limiter={t21} paginator={t22} actions={t27} />;
    $[66] = columns;
    $[67] = events;
    $[68] = t20;
    $[69] = t21;
    $[70] = t22;
    $[71] = t27;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== counter || $[74] !== events || $[75] !== t12 || $[76] !== t14 || $[77] !== t19 || $[78] !== t28) {
    t29 = <>{t11}<ListingLayout data={events} title={t12} customHeaderElement={t14} type="compact" counter={counter} filterData={t19}>{t28}</ListingLayout></>;
    $[73] = counter;
    $[74] = events;
    $[75] = t12;
    $[76] = t14;
    $[77] = t19;
    $[78] = t28;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  return t29;
};
export const getServerSideProps = getBaseServerSideProps(calendarLoco, 'header.top_menu.events');
export default Calendar;
function _temp(event) {
  return <div className="truncate"><LinkWithoutPrefetch className="text-brand-primary hover:text-text-secondary ring-brand-primary rounded-xs w-full outline-hidden ring-offset-1 focus-visible:ring-2" href={`/calendar/${event.id}?eventType=${event.eventType}`}>{event.name}</LinkWithoutPrefetch></div>;
}
function _temp2(value, onChange) {
  return <FormInputSearch key="events-search-filter" onClear={() => onChange("")} value={value} onChange={e => onChange(e.target.value)} testAttributePostfix="search-input" />;
}
function _temp3(event_3) {
  return `calendar/${event_3.id}?eventType=${event_3.eventType}`;
}